<template>
    <div
        class="EventCardFeatured"
    >
        <div class="EventCardFeatured__content">
            <div class="text--white mb-base">
                <span class="EventCardFeatured__day">{{ startDate.day }}</span>
                <span class="EventCardFeatured__month">{{ startDate.month }}</span>
                <div v-if="!oneDayEvent" class="EventCardFeatured__end-date">
                    <span class="EventCardFeatured__divider">⬤</span>
                    <span class="EventCardFeatured__day">{{ endDate.day }}</span>
                    <span class="EventCardFeatured__month">{{ endDate.month }}</span>
                </div>
            </div>
            <BaseTag
                v-if="tag"
                :title="tag"
            >
            </BaseTag>
            <h2 class="uppercase text--white mb-spacer">{{ heading }}</h2>
            <div>
                {{ truncatedText }}
            </div>
            <BaseButton
                :href="url"
                modifier="ghost"
            >
                {{ buttonText }}
            </BaseButton>
        </div>
        <div
            class="EventCardFeatured__image lazyload"
            :data-bgset="image"
        >
        </div>
    </div>
</template>
<script>
export default {
    name: 'EventCardFeatured',
    props: {
        heading: {
            type: String
        },
        text: {
            type: String
        },
        buttonText: {
            type: String
        },
        startDate: {
            type: Object
        },
        endDate: {
            type: Object
        },
        tag: {
            type: String
        },
        placeholder: {
            type: String
        },
        image: {
            type: String
        },
        ratio: {
            type: Number
        },
        url: {
            type: String
        }
    },
    computed: {
        oneDayEvent() {
            return JSON.stringify(this.startDate) === JSON.stringify(this.endDate);
        },
        truncatedText() {
            if (this.text) {
                const ellipses = this.text.length >= 250 ? '...' : '';
                return `${this.text.slice(0, 250)} ${ellipses}`;
            }
            return '...';
        }
    }
}
</script>
<style lang="scss" scoped>
    .EventCardFeatured {
        width: 100%;
        @include media-query(lap-and-up) {
            display:-ms-grid;
            display: grid;
            -ms-grid-columns: 2fr 3fr;
            grid-template-columns: 2fr 3fr;
            -ms-grid-rows: 1fr;
            grid-template-rows: 1fr;
        }
    }

    h2 {
        font-family: "NationalBlack", Helvetica, sans-serif;
        font-size: 34px;
        line-height: 0.9em;
    }

    .BaseTag {
        display: inline-flex;
    }

    .EventCardFeatured__image {
        position: relative;
        background-size: cover;
        background-position: center;

        &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: getColor('black');
            opacity: 0.15;
            transition: all ease-out 0.456s;
        }

        &:hover {
            &:after {
                opacity: 0.45;
            }
        }

        @include media-query(lap-and-up) {
            -ms-grid-column: 2;
            -ms-grid-row: 1;
            grid-column: 2;
            grid-row: 1;
        }
    }

    .EventCardFeatured__content {
        background: $action-color;
        padding: getSpacing(spacer);

        @include media-query(lap-and-up) {
            padding: getSpacing(large) 2.5rem;
            -ms-grid-column: 1;
            -ms-grid-row: 1;
            grid-column: 1;
            grid-row: 1;
        }

        > div {
            color: getColor('white');
            line-height: 1.3;
        }
    }

    .BaseButton {
        margin-top: getSpacing(spacer);
    }

    .EventCardFeatured__day {
        font-size: 3.8rem;
        line-height: 0;
        letter-spacing: -1px;
        font-family: "NationalBlack", Helvetica, sans-serif;
    }

    .EventCardFeatured__month {
        font-size: 1.5rem;
        line-height: 0;
        vertical-align: top;
        text-transform: uppercase;
        letter-spacing: -1px;
        font-family: "NationalBlack", Helvetica, sans-serif;
    }

    .EventCardFeatured__divider {
        font-size: 8px;
        vertical-align: text-top;
        margin-left: 10px;
        margin-right: 10px;
    }

    .EventCardFeatured__end-date {
        display: inline;
    }
</style>
